module.exports = __webpack_public_path__ + "static/media/credit_cards_gray.937bc901.svg";